import React from 'react'
import { makeStyles, Box, Typography } from '@material-ui/core'
import { clsx } from 'clsx'
import { ContainedPinkButton } from '../components/buttons/Buttons'
import { useHistory } from 'react-router-dom'
import image_2 from "../images/image_2.png"
import image_3 from "../images/image_3.jpg"

const useStyles = makeStyles((theme) => ({
    sectionTitle: {
        fontFamily: '"Cormorant Garamond", serif',
        fontSize: "52px",
        fontWeight: 400,
        lineHeight: "100%",
        textAlign: "left",
        [theme.breakpoints.down('sm')]: {
            fontSize: '36px',
            lineHeight: '100%',
        },
    },
    sectionText: {
        fontFamily: "'Roboto', sans-serif",
        fontSize: '18px',
        color: '#ffffff',
        lineHeight: "27px",
        fontWeight: 200,
        [theme.breakpoints.down('sm')]: {
            fontSize: '16px',
            lineHeight: '24px',
        }
    },
    creatorSection: {
        padding: "0px 0 0 0",
        width: "100%",
        margin: "0 auto",
        [theme.breakpoints.down('sm')]: {
            padding: "0px 0 0 0",
        }
    },
    creatorContent: {
        display: 'flex',
        justifyContent: 'space-between',
        backgroundColor: "#1B1B1B",
        height: "700px",                    /* 27"+ monitors (≥1920px) */
        [theme.breakpoints.down('lg')]: {
            height: "590px",                /* 13.3" laptops (1280–1920px) */
        },
        [theme.breakpoints.down('md')]: {
            flexWrap: "wrap",
            height: "auto",                 /* tablet / mobile — wraps */
        },
    },
    creatorImage: {
        width: "28.1875%", /* 451px / 1600px */
        height: "100%",
        objectFit: 'cover',
        objectPosition: 'top center',
        order: 0,
        [theme.breakpoints.down('md')]: {
            width: "50%",
            flex: "1 1 50%",
            height: "380px",
        },
        [theme.breakpoints.down('sm')]: {
            height: "308px",
        },
    },
    creatorText: {
        textAlign: 'center',
        maxWidth: 700,
        padding: "90px 2%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        order: 0,
        [theme.breakpoints.down('md')]: {
            order: 3,
            margin: "auto",
            padding: "30px 3%",
        },
    },
    creatorTitle: {
        color: "#FFD0E1",
        marginBottom: "24px",
        textAlign: "center"
    },
    creatorDescription: {
        marginBottom: "44px",
        [theme.breakpoints.down('sm')]: {
            marginBottom: "24px",
        },
    },
    explorePerksButton: {
        fontFamily: "'Roboto', sans-serif",
        fontWeight: 500,
        fontSize: '16px',
        borderRadius: "6px",
        height: "48px",
        [theme.breakpoints.down('sm')]: {
            width: '100% !important',
            padding: '12px 16px !important',
            height: "38px",
            fontSize: '14px',
        },
    },
}))

export const CreatorPerksSection: React.FC = () => {
    const classes = useStyles()
    const history = useHistory()
    return (
        <Box className={classes.creatorSection}>
            <Box className={classes.creatorContent}>
                <img
                    src={image_2}
                    className={classes.creatorImage}
                    alt="Creator left"
                />
                <Box className={classes.creatorText}>
                    <Typography variant="h3" className={clsx(classes.sectionTitle, classes.creatorTitle)}>
                        Elevate your brand. Maximize your earnings.
                    </Typography>
                    <Typography className={clsx(classes.sectionText, classes.creatorDescription)}>
                        We are currently reviewing applications for our founding Genesis Creators. Escape the noise and build your business on a platform that respects your value, protects your privacy, and connects you with high-net-worth members.
                    </Typography>
                    <ContainedPinkButton
                        text="Explore Creator Perks"
                        styles={classes.explorePerksButton}
                        onClick={() => history.push('/apply-as-creator')}
                    />
                </Box>
                <img
                    src={image_3}
                    alt="Creator right"
                    className={classes.creatorImage}
                />
            </Box>
        </Box>
    )
}
